var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"s-slice s-all-products"},[_c('s-side-menu',{staticClass:"s-all-products__side-menu",attrs:{"slices":_vm.slicesData,"links":_vm.links,"type":"combined","is-wide":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }